import React, { useState, useEffect } from 'react';

import Select from '../../../../components/Inputs/Select';
import Icon from '../../../../components/Icons';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import PageLoader from '../../../../components/PageLoader';

import ModalDataUserContent from './ModalDataUserContent';

import filterSchema from './schema';

import { cloneObject, translateContractsGroupsListToOptions, logout, checkIsSupport } from '../../../../utils';

import {
    consultarPerfil,
    getContatosPorContrato,
    getGruposContratoAndContratosByEmail,
    removerContatoDoContrato,
    removerPerfil,
} from '../../../../services';

import { useGlobal } from '../../../../contexts/Global/context';

import translateToSchema from './translateToSchema';
import * as S from './styles';

function UsuariosCadastrados({ setEditDataForm, setActiveTab }) {
    const { dataActiveContract, contractsGroupsList, dataLogin, contrastTheme, setShowSupportModal } = useGlobal();

    const [filterValues, setFilterValues] = useState({ ...filterSchema });
    const [users, setUsers] = useState([]);

    const [loading, setLoading] = useState(true);
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [userToDelete, setUserToDelete] = useState({});
    const [userDetails, setUserDetails] = useState({});
    const [pageLoading, setPageLoading] = useState(false);
    const [showModalDeleteUser, setShowModalDeleteUser] = useState(false);
    const [showModalDataUser, setShowModalDataUser] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);

    async function getFullDataUser(dataUser) {
        const contractsUser = await getGruposContratoAndContratosByEmail(dataUser.emailContato);

        const contractList = translateContractsGroupsListToOptions(contractsUser);

        const [profileUser] = await consultarPerfil({
            email: dataUser.emailContato?.toLowerCase(),
            contrato: filterValues.contract.value,
        });

        return { contractList, profileUser };
    }

    async function handleSeeDetails(dataUser) {
        setPageLoading(true);

        const { contractList, profileUser } = await getFullDataUser(dataUser);

        setUserDetails({ ...dataUser, contratos: contractList, profile: profileUser || { permissoes: [] } });

        setShowModalDataUser(true);

        setPageLoading(false);
    }

    async function handleEditUser(dataUser) {

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setPageLoading(true);

        const { profileUser, contractList } = await getFullDataUser(dataUser);

        const translated = translateToSchema({
            contractList,
            dataUser,
            dataActiveContract,
            contractNumber: filterValues.contract.value,
            profileUser,
        });

        setPageLoading(false);

        setEditDataForm(translated);

        setActiveTab('1');

        window.document.getElementById('page-content')?.scrollTo(0, 0);
    }

    function createIcons(row) {
        return (
            <S.ContainerIcons>
                <Icon
                    color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                    name="visibility"
                    tooltip={<S.TooltipText>Ver detalhes</S.TooltipText>}
                    onClick={() => handleSeeDetails(row)}
                />
                <Icon
                    color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                    name="edit"
                    tooltip={<S.TooltipText>Editar</S.TooltipText>}
                    onClick={() => handleEditUser(row)}
                />
                <Icon
                    color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                    name="delete"
                    tooltip={<S.TooltipText>Excluir</S.TooltipText>}
                    onClick={() => {
                        setUserToDelete(row);

                        setShowModalDeleteUser(true);
                    }}
                />
            </S.ContainerIcons>
        );
    }

    function handleChangeFilter(event) {
        const { id, value } = event;

        let filter = cloneObject(filterValues);

        filter = {
            ...filter,
            [id]: { ...filter[id], value },
        };

        setFilterValues({
            ...filter,
        });

        const hasSomeFilter = Object.values(filter).filter((field) => !!field.value).length > 0;

        if (hasSomeFilter) {
            const dataFiltered = users.filter(({ nomeContato, emailContato, nomeCargoContato }) => {
                const { name, email, role } = filter;

                return (
                    (name.value ? nomeContato?.toLowerCase()?.includes(name.value?.toLowerCase()) : true) &&
                    (email.value ? emailContato?.toLowerCase()?.includes(email.value?.toLowerCase()) : true) &&
                    (role.value ? nomeCargoContato?.toLowerCase()?.includes(role.value?.toLowerCase()) : true)
                );
            });

            setDataTable(dataFiltered);
        } else {
            setDataTable(users);
        }
    }

    async function loadUsersContract(contrato) {
        setLoading(true);

        setAlreadySearched(false);

        const response = await getContatosPorContrato(contrato || dataActiveContract.numero);

        const treatedResponse = response.map((row) => ({
            ...row,
            icons: createIcons(row),
        }));

        setUsers(treatedResponse);
        setDataTable(treatedResponse);
        setAlreadySearched(true);
        setLoading(false);
    }

    function handleSearchUsers(event) {
        const { value } = event;

        setFilterValues({
            ...filterValues,
            name: { ...filterValues.name, value: '' },
            email: { ...filterValues.email, value: '' },
            role: { ...filterValues.role, value: '' },
            contract: {
                ...filterValues.contract,
                value,
            },
        });

        loadUsersContract(value);
    }

    async function handleDeleteUser() {

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setLoadingDelete(true);

        const contractsUser = await getGruposContratoAndContratosByEmail(userToDelete.emailContato);

        const contractList = translateContractsGroupsListToOptions(contractsUser);

        const requests = contractList.map(async ({ codigo }) => {
            const [dataContato] = await getContatosPorContrato(codigo, userToDelete.emailContato);

            if (dataContato) {
                const deleteContato = await removerContatoDoContrato(codigo, dataContato.numeroSequencialContato);

                if (deleteContato.status !== 200) return { deleteContato: false, deletePerfil: false };

                const payload = { email: userToDelete.emailContato, contrato: codigo };

                const deletePerfil = await removerPerfil(payload);

                return { deleteContato, deletePerfil: deletePerfil.status };
            }

            return false;
        });

        await Promise.all(requests);

        if (userToDelete.emailContato === dataLogin.email) logout();

        setLoadingDelete(false);

        setShowModalDeleteUser(false);

        loadUsersContract(filterValues.contract.value);
    }

    useEffect(() => {
        const treatedContractList = translateContractsGroupsListToOptions(contractsGroupsList);

        setFilterValues({
            ...filterValues,
            contract: {
                ...filterValues.contract,
                value: dataActiveContract.numero,
                options: treatedContractList,
            },
        });

        loadUsersContract();
    }, []);

    const columnsHead = [
        {
            key: 'nome',
            selector: (user) => user.nomeContato || '-',
            name: 'Nome',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '30%' }),
        },
        {
            key: 'email',
            selector: (user) => user.emailContato || '-',
            name: 'E-mail',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '40%' }),
        },
        {
            key: 'cargo',
            selector: (user) => user.nomeCargoContato || '-',
            name: 'Cargo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '20%', height: '60px' }),
        },
        {
            key: 'botoes',
            selector: (user) => createIcons(user),
            name: '',
            sortable: false,
            direction: 'left',
            customStyles: () => ({ width: '10%', height: '60px', zIndex: '999' }),
        },
    ];

    return (
        <>
            {alreadySearched && (
                <>
                    <S.FiltersLabel>Filtrar por: </S.FiltersLabel>

                    <S.ContainerFilter>
                        <Select
                            field={filterValues.contract}
                            disabled={loading}
                            onChange={handleSearchUsers}
                            hasDefaultOption={false}
                        />
                        <S.CustomInput field={filterValues.name} onChange={(event) => handleChangeFilter(event)} />
                        <S.CustomInput field={filterValues.email} onChange={(event) => handleChangeFilter(event)} />
                        <S.CustomInput field={filterValues.role} onChange={(event) => handleChangeFilter(event)} />
                    </S.ContainerFilter>
                </>
            )}

            <S.CustomDataTableMui
                data={dataTable}
                loading={loading}
                columns={columnsHead}
                emptyMessage="Não encontramos resultados. Você pode fazer uma nova pesquisa."
                alreadySearched={alreadySearched}
                firstOrderBy="numCarteirinha"
            />

            <Modal
                title="Você quer excluir o usuário?"
                subtitle="O usuário será definitivamente excluído da plataforma."
                visible={showModalDeleteUser}
                footer={null}
            >
                <Button type="secondary" onClick={() => setShowModalDeleteUser(false)}>
                    Não quero
                </Button>
                <Button type="primary" loading={loadingDelete} disabled={loadingDelete} onClick={handleDeleteUser}>
                    Sim, quero
                </Button>
            </Modal>

            <Modal
                title={`Detalhes do usuário ${userDetails.emailContato?.toLowerCase()}`}
                modalSize="lg"
                subtitle={<ModalDataUserContent dataUser={userDetails} />}
                visible={showModalDataUser}
                onCancel={() => setShowModalDataUser(false)}
                footer={null}
            >
                <Button
                    type="secondary"
                    onClick={() => {
                        setShowModalDataUser(false);
                        handleEditUser(userDetails);
                    }}
                >
                    Editar
                </Button>
                <Button type="primary" onClick={() => setShowModalDataUser(false)}>
                    OK
                </Button>
            </Modal>

            <PageLoader loading={pageLoading} />
        </>
    );
}

export default UsuariosCadastrados;
